import { Tile2DHeader } from '@deck.gl/geo-layers/typed/tileset-2d';
import { BitmapBoundingBox } from '@deck.gl/layers/typed';

export const getTileSublayerBbox = (tile: Tile2DHeader<any>): (number[] & BitmapBoundingBox) | undefined => {
  const bbox = tile?.boundingBox;
  const west = bbox[0][0];
  const south = bbox[0][1];
  const east = bbox[1][0];
  const north = bbox[1][1];
  return [west, south, east, north];
};
